import { Outlet, useParams } from "react-router-dom";
import { AppRouteProps } from "src/components/router/AppRoute";
import CreateTab, { registerWrapperComponent } from "src/hooks/useTab";
import React from "react";
import { wrapRoutes } from "src/components/router/AuthWrapper";
import IsolationTypeDefinition from "./type-definitions/pages/list";
import IsolationRequestsList from "./request-list/pages/list";
import IsolationRequest from "./request/pages/create";

// Wrapper component'leri başlangıçta register et
registerWrapperComponent('isolation/type-definitions', () => React.createElement(IsolationTypeDefinition));
registerWrapperComponent('isolation/request-list', () => React.createElement(IsolationRequestsList));
registerWrapperComponent('isolation/request', () => React.createElement(IsolationRequest));

export const isolationRoutes: AppRouteProps[] = [
  {
    path: "isolation",
    element: (
      <PatientLayout>
        <Outlet />
      </PatientLayout>
    ),
    children: wrapRoutes([
        { path: 'type-definitions', element: <IsolationWrapper title="İzolasyon Tip Tanımlama" element={IsolationTypeDefinition} path="isolation/type-definitions" />,role: "frmIsolationTypeDefinition" },
        { path: "request-list", element: <IsolationWrapper title="İzolasyon İstekleri" element={IsolationRequestsList} path="isolation/request-list" />, role: "frmIsolationRequestsList" },
        { path: "request/:id", element: <PatientTab title="İzolasyon İsteği" element={IsolationRequest} path="isolation/request" />, role: "frmIsolationRequestsList" }
    ]),
  },
];

function PatientLayout(props: any) {
  return <>{props.children}</>;
}

function IsolationWrapper({ title, element: Element, path }: { title: string; element: any; path: string }) {
  return <CreateTab title={title} element={<Element />} path={path} />;
}

function PatientTab({ title, element: Element, path }: { title: string; element: any; path: string }) {
  const { id } = useParams();
  const patientId = id ? parseInt(id) : null;
  
  return <CreateTab title={title} element={<Element />} patientId={patientId} path={path} />;
}